
// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();




export const getTerminalDescansosService = async() => {
   
    try {
        
        return await http.get<any>('/v1/employee-terminal-descanso'); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getTerminalsService ',error);

    }
}

export const createTerminalDescansoService = async(area:object, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.post<any>('/v1/employee-terminal-descanso', area, setPercentajeCCompany); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('createTerminalService ',error);

    }
}



export const getTerminalDescansoDetailService = async(terminalId:string) => {
   
    try {

        return await http.get<any>(`/v1/employee-terminal-descanso/${terminalId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getTerminalDescansoDetailService ',error);

    }
}


export const updateTerminalDescansosDetailService = async(terminal: object) => {
   
    try {

        return await http.put<any>(`/v1/employee-terminal-descanso`, terminal); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('updateTerminalDetailService ',error);

    }
}




export const desactiveTerminalDescansoService = async(terminalId: string) => {
   
    try {

        return await http.delete<any>(`/v1/employee-terminal-descanso/${terminalId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('desactiveTerminalServiceDescanso ',error);

    }
}



export const activeTerminalDescansoService = async(terminalId: string) => {
   
    try {

        return await http.patch<any>(`/v1/employee-terminal-descanso/${terminalId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('activeTerminalService ',error);

    }
}



export const getTerminalsByPaginateService = async(page:number) => {
   
    try {

        return await http.get<any>(`/v1/employee-terminal-descanso?page=${page}&take=10`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getTerminalsByPaginateService ',error)
    }
}